import {
  Step5ErrorScreen,
  Step5PendingScreen,
  Step5SuccessScreen,
} from '@/AutoEnrollment/ui/atoms'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { LogaltyResponseStatus } from '@/Logalty/domain'
import { LogaltyStatusChecker } from '@/Logalty/ui/organisms'
import { MedalliaSurvey } from './MedalliaSurvey'

const renderState = (state: LogaltyResponseStatus): JSX.Element => {
  switch (state) {
    case LogaltyResponseStatus.Pending:
      return <Step5PendingScreen />
    case LogaltyResponseStatus.Success:
      return <><Step5SuccessScreen /><MedalliaSurvey/></>
    case LogaltyResponseStatus.Error:
      return <Step5ErrorScreen />
    default:
      return <Step5PendingScreen />
  }
}

export const AutoEnrollmentStep5 = (): JSX.Element => {
  const { autoEnrollmentModel, logalty } = useAutoEnrollment()
  const { getSignStatus, signStatus } = logalty

  return (
    <LogaltyStatusChecker
      logalty={logalty}
      currentModel={autoEnrollmentModel}
      getSignStatus={() => getSignStatus(autoEnrollmentModel?.processType || 2)}
    >
      {renderState(signStatus)}
    </LogaltyStatusChecker>
  )
}
